var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"option",style:(_vm.style),on:{"click":_vm.click}},[_c('div',{staticClass:"gradient"}),_c('div',{staticClass:"d-flex content"},[_c('span',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }